import React from "react";
import { Link, useHistory } from 'react-router-dom';
import moment from 'moment';
import NavBar from "../../components/NavBar";
import { DateRevivier, Session } from '../../Types';


const PreviousSessions: React.SFC<{}> = () => {

  let history = useHistory();

  const navBackHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    history.goBack();
  }

  const [sessions, setSessions] = React.useState([] as Session[]);

  React.useEffect(() => {
    let stored_sessions = localStorage.getItem("sessions");
    let previous_sessions: Session[] = [];
    if (stored_sessions) {
        let storedSessions = JSON.parse(stored_sessions, DateRevivier ) as Session[];
        if (!Array.isArray(storedSessions)){
            previous_sessions.push(storedSessions);
        } else {
            previous_sessions = storedSessions;
        }
        previous_sessions.sort( (a: Session ,b: Session ) => a.date.getTime() - b.date.getTime());
        setSessions(previous_sessions);
    }


  
  }, []);


  const clearHistoryHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if(window.confirm("Are you sure you want to delete all sessions?"))
    {
      localStorage.removeItem('sessions');
      setSessions([]);
    }
  }

  return (
    <>
      <NavBar 
        title="History"
        backBtnTitle="Back"
        backBtnClick={navBackHandler}
      />
      <h1>Previous Sessions</h1>
  		<div className="content-pane">
        
  		      <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Herd</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>

              {sessions.map((session) => {
                const link = "/summary#" + session.session_id;
                return <tr key={session.session_id}><td>{moment(session.date).format("DD/MM/YYYY")}</td><td>{session.herd}</td><td><Link to={link} >SUMMARY</Link></td></tr>
              })}
              {sessions.length === 0 &&
                <tr><td colSpan={3} className="align-center">There are no previous recordings</td></tr>
              }
              </tbody>
            </table>
            <button className="rpg_button small" onClick={clearHistoryHandler}>CLEAR ALL HISTORY</button>
  		</div>
    </>
   )
}

export default PreviousSessions;